import fileDownload from "js-file-download";
import { useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IDownloadExcelButton {
  id: string;
}

const DownloadExcelButton = ({ id }: IDownloadExcelButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const downloadExcel = () => {
    setIsLoading(true);
    provider
      .downloadFile(`subcontractorPurchaseInvoices/${id}/downloadExcel`)
      .then(({ data }: any) => {
        if (data) {
          fileDownload(data, `purchase-invoice-summary-${id}.xlsx`);
        } else {
          notify("The Excel doesn't exist.", "warning");
        }
        setIsLoading(false);
      })
      .catch((error: any) => {
        notify(`Error : ${error.message}`, "error");
        setIsLoading(false);
      });
  };

  return (
    <StyledButton variant="outlined" onClick={() => downloadExcel()}>
      {isLoading ? "Loading" : `Download Excel`}
    </StyledButton>
  );
};

export default DownloadExcelButton;
